import PrivacyPolicy from '../containers/PrivacyPolicy';
export default PrivacyPolicy;
